const BudgetItemDict = () => import(/* webpackChunkName: "manager" */ './Index');

export default {
    routes: [
        {
            path: '/proj/budget_item_dict',
            name: 'proj_budget_item_dict',
            component: BudgetItemDict
        }
    ]
}
